import ng from 'angular';

import versionData from './version.json';

export const configModule = ng.module('config', [])

.constant('versionData',
{
    build: versionData.build,
    date: versionData.date,
    version: versionData.version
});
